export default function InitImageStack() {
    const imageStackWrappers = document.querySelectorAll('.image-stack');
    if (imageStackWrappers.length === 0) return;

    imageStackWrappers.forEach((imageStackWrapper) => {
        const imageStack = Array.from(imageStackWrapper.querySelectorAll('.stack-image'));
        const prevArrowButton = imageStackWrapper.querySelector('.round-arrow-button.prev');
        const nextArrowButton = imageStackWrapper.querySelector('.round-arrow-button.next');
        let currentImageIndex = 0;

        prevArrowButton.addEventListener('click', (event) => {
            const image = imageStack[--currentImageIndex];
            setZIndex(image, imageStack.length - currentImageIndex);
            setTimeout(() => {
                image.classList.add('on-main');
            }, 50);

            updateButtons(prevArrowButton, nextArrowButton, imageStack, currentImageIndex);
        });

        nextArrowButton.addEventListener('click', (event) => {
            const image = imageStack[currentImageIndex];
            image.classList.remove('on-main');
            setTimeout(setZIndex, 150, image, -imageStack.length + currentImageIndex);
            ++currentImageIndex;

            updateButtons(prevArrowButton, nextArrowButton, imageStack, currentImageIndex);
        });

        updateButtons(prevArrowButton, nextArrowButton, imageStack, currentImageIndex);
    });
}

function setZIndex(element, index) {
    element.style.zIndex = index;
}

function updateButtons(prevButton, nextButton, imageStack, currentImageIndex) {
    if (prevButton !== null && currentImageIndex > 0) prevButton.style.display = 'flex';
    else prevButton.style.display = 'none';

    if (nextButton !== null && currentImageIndex < imageStack.length - 1) nextButton.style.display = 'flex';
    else nextButton.style.display = 'none';
}